import { OrganizationType } from "../utils/models"
import { GET_MY_ORGANIZATION } from "./../graphql/queries/getMyOrganization"
import { useQuery } from "@apollo/client"

interface UseMyOrganizationData {
  myOrganization: OrganizationType
}

export const useMyOrganization = () => {
  const { data, error, loading, refetch } = useQuery<UseMyOrganizationData>(GET_MY_ORGANIZATION, {})
  return {
    myOrganization: data?.myOrganization,
    error,
    orgLoading: loading,
    refetch,
  }
}
